import { render, staticRenderFns } from "./HandicapPromotionData.vue?vue&type=template&id=382acdb6&scoped=true"
import script from "./HandicapPromotionData.vue?vue&type=script&lang=js"
export * from "./HandicapPromotionData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "382acdb6",
  null
  
)

export default component.exports